import React from 'react';
import './ShippingPolicy.css';
import { ProfileBG } from '../../Assests/Assests';

const ShippingPolicy = () => {
  return (
    <div className="shipping-policy-container">
      <div className="image-container">
        {/* <img src={ProfileBG} alt="Shipping Bag" className="bag-image" /> */}
        <div className="image-text">Shipping Policy</div>
      </div>
      <div className="shipping-text">
        <p>
          At Riymay, we take pride in delivering our premium apparels and accessories worldwide with the utmost care and security.
          Every order is thoughtfully packaged based on the material of the product, ensuring it reaches you in perfect condition.
        </p>
        <p>
          Orders are processed within 5-7 business days before being dispatched. Domestic deliveries within India generally take 2-4 days,
          whereas international shipping may take anywhere from 5-10 days, depending on the destination.
        </p>
        <p>
          We collaborate with trusted carriers like FedEx, DHL, Shiprocket, and Delhivery to ensure timely and safe deliveries.
          Shipping charges are determined based on the delivery location, and we offer free shipping for orders above ₹5000.
        </p>
        <p>
          For international orders, customers are responsible for any import duties and taxes. Tracking details will be emailed once the order is dispatched,
          allowing customers to monitor their shipment in real-time.
        </p>
        <p>
          If a customer needs to modify their shipping address after placing an order, they must contact our support team immediately.
          We deliver to all types of addresses, including PO boxes and military locations. However, we do not offer signature confirmation for high-value orders at this time.
        </p>
        <p>
          For customers residing in remote locations, additional shipping charges may apply depending on the accessibility of the area.
          Lost or damaged packages will be compensated with store credit.
        </p>
        <p>
          Additionally, we offer recurring deliveries for select products and ensure special handling for fragile, high-value, or hazardous items.
          For any shipping-related concerns or inquiries, please feel free to contact our dedicated support team via email.
        </p>
      </div>
    </div>
  );
};

export default ShippingPolicy;
